/**
 * Collection : filtres Search & Discovery dans une modale + bouton filtre header (mobile).
 */
(function () {
  'use strict';

  var DESKTOP_MIN = 769;
  var placeholder = null;

  function isDesktop() {
    return window.matchMedia('(min-width: ' + DESKTOP_MIN + 'px)').matches;
  }

  function getSidebar() {
    return document.getElementById('CollectionSidebar');
  }

  function getModalBody() {
    return document.getElementById('collection-filters-modal-body');
  }

  function getModalRoot() {
    return document.getElementById('collection-filters-modal');
  }

  function getOpenButtons() {
    return document.querySelectorAll(
      '#collection-open-filters, #collection-open-filters-head'
    );
  }

  function ensurePlaceholder() {
    var sidebar = getSidebar();
    if (!sidebar || !sidebar.parentNode) return;
    if (placeholder && placeholder.parentNode) return;
    placeholder = document.createElement('div');
    placeholder.id = 'CollectionSidebarPlaceholder';
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.style.display = 'none';
    sidebar.parentNode.insertBefore(placeholder, sidebar);
  }

  function moveSidebarToModal() {
    var sidebar = getSidebar();
    var body = getModalBody();
    if (!sidebar || !body) return;
    ensurePlaceholder();

    var root = getModalRoot();

    if (isDesktop()) {
      document.body.classList.add('collection-filters-desktop-modal');
      body.appendChild(sidebar);
      syncTriggerVisibility();
      return;
    }

    document.body.classList.remove('collection-filters-desktop-modal');
    if (root && root.classList.contains('is-open')) {
      body.appendChild(sidebar);
    } else if (sidebar.parentNode === body && placeholder && placeholder.parentNode) {
      placeholder.parentNode.insertBefore(sidebar, placeholder);
    }
    syncTriggerVisibility();
  }

  function syncTriggerVisibility() {
    var sidebar = getSidebar();
    var hasFilters = sidebar && sidebar.querySelector('.filter-form');
    var showDesktop = isDesktop() && hasFilters;
    var showMobile = !isDesktop() && hasFilters;

    var btnBar = document.getElementById('collection-open-filters');
    if (btnBar) {
      if (isDesktop()) {
        btnBar.style.display = showDesktop ? 'inline-flex' : 'none';
      } else {
        btnBar.style.display = 'none';
      }
      btnBar.setAttribute('aria-hidden', showDesktop ? 'false' : 'true');
    }

    var btnHead = document.getElementById('collection-open-filters-head');
    if (btnHead) {
      if (!isDesktop()) {
        btnHead.style.display = showMobile ? 'inline-flex' : 'none';
      } else {
        btnHead.style.display = 'none';
      }
      btnHead.setAttribute('aria-hidden', showMobile ? 'false' : 'true');
    }
  }

  function syncExpanded(open) {
    getOpenButtons().forEach(function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function openModal() {
    var root = getModalRoot();
    if (!root) return;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('collection-filters-modal-open');
    syncExpanded(true);
    moveSidebarToModal();
    if (typeof window.LovenUpdateFilterModalFooter === 'function') {
      window.LovenUpdateFilterModalFooter();
    }
    var closeBtn = root.querySelector('[data-collection-filters-close]');
    if (closeBtn) {
      setTimeout(function () {
        closeBtn.focus();
      }, 50);
    }
  }

  function closeModal() {
    var root = getModalRoot();
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('collection-filters-modal-open');
    syncExpanded(false);
    moveSidebarToModal();
  }

  window.LovenCloseCollectionFiltersModal = closeModal;

  function bindModalUi() {
    if (window.__lovenCollectionFiltersModalBound) return;
    window.__lovenCollectionFiltersModalBound = true;
    var root = getModalRoot();
    var btns = getOpenButtons();
    if (!root || !btns.length) return;

    btns.forEach(function (openBtn) {
      openBtn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    });

    root.querySelectorAll('[data-collection-filters-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeModal();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  function init() {
    if (!getModalBody()) return;
    bindModalUi();
    moveSidebarToModal();

    window.addEventListener('resize', debounceResize(moveSidebarToModal));
  }

  function debounceResize(fn) {
    if (window.theme && theme.utils && theme.utils.debounce) {
      return theme.utils.debounce(200, fn);
    }
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, 200);
    };
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('collection:reloaded', function () {
    closeModal();
    placeholder = null;
    moveSidebarToModal();
    if (typeof theme !== 'undefined' && theme.collapsibles && theme.collapsibles.init) {
      var sb = getSidebar();
      if (sb) theme.collapsibles.init(sb);
    }
    syncTriggerVisibility();
  });
})();
